import React, { useContext, useState } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { IconFileTypePdf } from "@tabler/icons-react";
import { useFiltersContext } from '../hooks/useFiltersContext';
import Toast from '../../../../Util/Toast/Toast';
import EntityProjectsContext from '../../../../EntityProjects/context/EntityProjects.context';
import { Button } from '@mui/material';

const getVisibleElement = () => {
    const elements = document.getElementsByClassName(
        'services-container-dashboards'
    );

    for (let element of elements) {
        const rect = element.getBoundingClientRect();
        if (
            rect.bottom > 0 &&
            rect.right > 0 &&
            rect.top <
                (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <
                (window.innerWidth || document.documentElement.clientWidth)
        ) {
            return element;
        }
    }

    return null;
};

const toggleAnimation = (disable) => {
    const elements = [
        ...document.getElementsByClassName('chart-container-dashboards')
    ];

    for (let element of elements) {
        if (disable) {
            element.classList.add('no-animation');
        } else {
            element.classList.remove('no-animation');
        }
    }
};

const PDFGeneratorButton = ({ className }) => {
    const { filters } = useFiltersContext();
    const [isGenerating, setIsGenerating] = useState(false);
    const { infos } = useContext(EntityProjectsContext);

    const generatePDF = async () => {
        const toastId = Toast.info('Gerando PDF...', '', {
            autoClose: false
        });

        setIsGenerating(true);
        toggleAnimation(true);

        try {
            const serviceLetterElement = getVisibleElement();

            if (!serviceLetterElement) {
                throw new Error(
                    'Nenhum elemento visível encontrado para gerar o PDF.'
                );
            }

            const pdfPortraitWidth = 595.28;
            const pdfPortraitHeight = 841.89;
            const pdfLandscapeWidth = 841.89;
            const pdfLandscapeHeight = 595.28;

            const canvas = await html2canvas(serviceLetterElement, {
                scale: 2,
                useCORS: true
            });

            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;

            const isLandscape = canvasWidth > canvasHeight;
            const pdfWidth = isLandscape ? pdfLandscapeWidth : pdfPortraitWidth;
            const pdfHeight = isLandscape
                ? pdfLandscapeHeight
                : pdfPortraitHeight;

            const scaleX = pdfWidth / canvasWidth;
            const scaleY = pdfHeight / canvasHeight;
            const scale = Math.min(scaleX, scaleY);

            const imgWidth = canvasWidth * scale;
            const imgHeight = canvasHeight * scale;

            const xOffset = (pdfWidth - imgWidth) / 2;
            const yOffset = (pdfHeight - imgHeight) / 2;

            const pdf = new jsPDF(
                isLandscape ? 'landscape' : 'portrait',
                'pt',
                'a4'
            );

            const imgData = canvas.toDataURL('image/png');
            pdf.addImage(imgData, 'PNG', xOffset, yOffset, imgWidth, imgHeight);

            Toast.clear(toastId);
            Toast.info('Baixando PDF...');

            pdf.save(
                `dashboard-${filters.unidade.label}-${filters.ano.label}-${
                    filters?.competencia?.label
                }-${infos?.banner?.title}-${new Date()
                    .toLocaleDateString()
                    .replace(/\//g, '-')}.pdf`
            );
        } catch (error) {
            Toast.error(`Erro ao gerar PDF: ${error.message}`);
        } finally {
            toggleAnimation(false);
            setIsGenerating(false);
        }
    };

    return (
        <Button
            onClick={generatePDF}
            variant="outlined"
            className={`${className} align-self-end`}
            style={{
                height: '40px',
                borderRadius: '8px',
                borderColor: '#E9EAEB',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '14px',
                padding: '0 16px',
                color: '#252B37'
            }}
            sx={{
                '&:hover': {
                    backgroundColor: '#fff',
                    borderColor: '#E9EAEB',
                    boxShadow: 'none'
                }
            }}
            disabled={isGenerating}
        >
            <IconFileTypePdf size={30} />
        </Button>
    );
};

export default PDFGeneratorButton;
